export default __webpack_public_path__ + "static/martin-6ff7efcfc9b52a7ef486cfef5aaa9f2a.png";